// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"MonitorEditDialog-primaryButton-1byrEC","paper":"MonitorEditDialog-paper-y9QcYP"};